var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.082 8.575c1.176.107 2.352.172 3.55.258.806.086 2.004.129 2.309 1.053.304.925-.632 1.678-1.242 2.194-.915.774-1.808 1.505-2.722 2.28.283 1.139.566 2.257.849 3.397.174.774.48 1.935-.305 2.494-.806.56-1.808-.064-2.505-.494-1.001-.603-2.003-1.226-3.005-1.828-1.024.602-2.026 1.247-3.05 1.849-.696.409-1.698 1.075-2.482.495-.806-.56-.48-1.72-.305-2.495l.85-3.419c-.894-.774-1.808-1.505-2.723-2.28-.61-.537-1.546-1.268-1.242-2.193.305-.924 1.503-.989 2.31-1.053 1.197-.086 2.373-.15 3.55-.258.457-1.075.892-2.15 1.35-3.226.326-.752.762-1.849 1.742-1.849.958 0 1.394 1.097 1.72 1.85.458 1.074.893 2.15 1.35 3.225z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled_star.ca146edd.svg";
export { ForwardRef as ReactComponent };